export default {
  首页: "Home",
  资产: "Assets",
  币币: "Currency",
  快捷买币: "P2P Trade",
  "支持多种方式购买，购买更简单":
    "Support multiple ways to buy, buy more simple",
  语言设置: "Language settings",
  确认恢复: "Confirm recovery",
  "输入邮箱，方便我们联系您": "Enter your email so we can contact you",
  划转: "Transfer",
  行情: "Markets",
  "24H成交": "24H transaction",
  累计收益: "Cumulative income",
  充值时间: "Recharge time",
  到期时间: "Expire date",
  数量: "Quantity",
  操作: "Operate",
  资产信息: "Asset Information",
  复制地址: "Copy address",
  链名称: "Chain",
  充值地址: "Recharge address",
  收款地址: "Payment address",
  账单: "Bill",
  提现金额: "Withdrawal Amount",
  接收地址: "Receiving address",
  交易密码: "Transaction password",
  提现全部: "Withdraw all",
  保存图片: "Save Picture",
  输入您的交易密码: "Transaction password",
  确定: "Sure",
  地址: "Address",
  注册时间: "Sign time",
  取消: "Cancel",
  是否划转: "Whether to transfer",
  登录: "Log in",
  我的地址: "My address",
  登录密码和交易密码: "Login password and transaction password",
  注册: "Register",
  密码: "Password",
  设置密码: "Set password",
  重复密码: "Repeat password",
  新密码: "New password",
  确认新密码: "Confirm the new password",
  充值: "Recharge",
  充值货币: "Deposit",
  合约账户充值: "Futures account recharge",
  账户充值: "Account recharge",
  其他: "Other",
  我的邀请码: "Invitation code",
  提现: "Withdraw",
  客服: "Customer",
  持有详情: "Holding details",
  请输入内容: "Please enter content",
  邀请好友来领取奖励: "Invite friends to receive rewards",
  复制链接: "Copy",
  重复设置新的密码: "Repeat setting new password",
  保存: "Save",
  我的: "Mine",
  "邮箱/手机号": "Email/Mobile Number",
  备注: "Remark",
  地址管理: "My address",
  我的团队: "Teams",
  联系我们: "Contact us",
  竭诚为您服务: "Sincerely at your service",
  提取收益: "Withdrawal income",
  带给我的收益: "My benefit",
  添加: "Add",
  名称: "Name",
  添加地址: "Add address",
  修改地址: "Change address",
  可提现: "Can be withdrawn",
  安全中心: "Security center",
  收益划转: "Income transfer",
  通知中心: "Notification",
  "累计收益:": "Cumulative Earnings:",
  注册用户: "Registered user",
  奖励规则: "Reward Rules",
  帮助反馈: "Help feedback",
  邀请好友: "Invite friends",
  恢复身份: "Restore identity",
  选择语言: "Choose language",
  设置新的密码: "Set new password",
  暂无活动: "No activity",
  "月增长量(+)": "Monthly Growth (+)",
  可提取: "Extractable",
  反馈类型: "Feedback type",
  赠送: "Give away",
  已经复制: "Copied",
  保存成功: "Successfully saved",
  划转成功: "Successfully transfer",
  过期: "Expired",
  提交成功: "Submitted successfully",
  "服务器繁忙，稍后在试": "The server is busy, try later",
  全部: "All",
  一级: "Level 1",
  二级: "Level 2",
  三级: "Level 3",
  级: "Level",
  删除成功: "Successfully deleted",
  选择地址: "Choose address",
  不再提醒: "No reminders",
  "最小充值金额：": "Minimum recharge:",
  选择币种: "Select currency",
  输入投资金额: "Investment amount",
  输入账户密码: "Password",
  投资: "Invest",
  订单编号: "Order id",
  投资周期: "Cycle",
  投资资金: "Funds",
  投资时间: "Time",
  状态: "State",
  投资中: "Investmenting",
  已到期: "Expired",
  暂无数据: "No data",
  转入: "Transfer in",
  邮箱: "Mail",
  请输入邮箱: "Email",
  请输入格式正确的邮箱: "Email address",
  请输入验证码: "Verification code",
  获取验证码: "Get code",
  请输入邀请码: "Invitation code",
  今天: "Today",
  昨天: "Yesterday",
  最近七天: "Last seven days",
  邀请: "Invite",
  购买数量: "Purchase quantity",
  产品详情: "Product Details",
  币种: "Currency",
  利息币种: "Interest currency",
  理财类型: "Financial type",
  产品费率: "Product rate",
  进行中: "Processing",
  每天: "Every day",
  请输入搜索关键词: "Please search keyword",
  通知: "Notice",
  查看更多: "More",
  理财宝: "HODL & Earn",
  周期: "Cycle",
  年利率: "APR",
  更多产品: "More products",
  灵活存取: "Flexible Deposits",
  稳定收益: "Stable Returns",
  合约指南: "Help Center",
  资金划转出: "Fund transfer out",
  矿池收益: "Mining pool revenue",
  提现手续费: "Withdrawal fee",
  冻结资金: "Freeze funds",
  解冻资金: "Unfreeze funds",
  闪兑支出: "Flash spending",
  闪兑收入: "Flash exchange income",
  闪兑手续费: "Flash exchange fee",
  合约支出: "Futures expenditure",
  合约收入: "Futures revenue",
  输入的金额不可大于可用金额:
    "The amount entered cannot be greater than the available amount",
  全部兑换成功: "Successfully",
  返回: "Return",
  查看历史: "View History",
  闪兑历史: "Flash history",
  支付: "Pay",
  获取: "Obtain",
  时间: "Time",
  手续费: "Handling fee",
  折扣: "Discount",
  价格: "Price",
  逐仓: "Isolated",
  全仓: "Cross",
  市价委托: "Market order",
  限价委托: "Limit order",
  请输入本金: "Amount",
  请输入价格: "Price",
  "可做空/做多": "Short/Long",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Cost",
  做多: "Long",
  做空: "Short",
  仓位信息: "Position information",
  一键平仓: "Close all",
  永续: "",
  浮动盈亏: "Unrealized P&L",
  平仓: "Close",
  反向开仓: "RVS Open",
  一键撤销: "One-click undo",
  倍杠杆: "x leverage",
  执行价格: "Strike price",
  委托数量: "Number of orders",
  保证金: "Margin",
  成交价: "Open Price",
  创建时间: "Create Date",
  撤销: "Revoke",
  合约市场: "Futures market",
  交易方向: "Trading direction",
  委托价格: "Order price",
  委托金额: "Commission amount",
  资金费率: "Funding rate",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "A recurring fee paid by long and short traders, settled every 8 hours.",
  "资金费率为正，多方向空方支付资金费用。":
    "The funding rate is positive, and the long side pays the short side the funding fee.",
  "资金费率为负，空方向多方支付资金费用。":
    "The funding rate is negative, and the short side pays the funding fee to the multiple parties.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Are you sure you want to open a position in reverse? Reverse opening position will be bought with the current opposite position",
  "仓位止盈/止损": "Position Take Profit/Stop Loss",
  合约名称: "Futures",
  开仓价格: "Open price",
  指数价格: "Index price",
  止盈设置: "Take Profit Setting",
  请输入止盈价: "Please enter take profit price",
  "当指数价格触达*时，将会触发委托平仓":
    "When the index price touches {0}, it will trigger the order to close the position",
  预计盈亏: "Liquidation Qty",
  当前仓位: "Current position",
  平仓金额: "Liquidation amount",
  仓位模式: "Position Mode",
  全仓模式: "Full warehouse mode",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "All available funds in the futures account are regarded as available margin. When the position loss exceeds the account balance, the position will be liquidated and all margin and positions will be lost. Please note that",
  逐仓模式: "Isolated margin mode",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "It will cause a certain amount of margin in the futures account to be allocated to the position. If the margin loss falls below the maintenance margin level, the position is liquidated. In the isolated position mode, you can increase and decrease the margin for this position.",
  "是否撤销？": "Is it revoked?",
  "是否一键撤销？": "Is it one-click undo?",
  "是否一键平仓？": "Whether to close a position with one click?",
  持仓保证金: "Position margin",
  风险率: "Risk",
  未实现盈亏: "Unrealized P&L",
  可用保证金: "Free margin",
  净值: "New worth",
  账户余额: "Balance",
  合约计算器: "Calculator",
  交易记录: "Transaction Record",
  "*倍杠杆": "{num} x leverage",
  "平仓盈亏：": "Closing P&L:",
  时间筛选: "Time filter",
  仓位类型: "Position Type",
  订单状态: "Order Status",
  订单类型: "Order Type",
  平仓价格: "Closing price",
  持仓数量: "Quantity",
  "手续费(%)": "Handling fee (%)",
  平仓时间: "Closing time",
  平仓类型: "Closing type",
  手动平仓: "Close a position manually",
  强制平仓: "Forced liquidation",
  近1天: "1 day",
  近7天: "7 days",
  近30天: "30 days",
  近180天: "180 days",
  持仓: "Position",
  已取消: "Cancelled",
  分时: "Time",
  "24H额(USDT)": "24H amount (USDT)",
  "24H低": "24H low",
  "24H量(BTC)": "24H volume (BTC)",
  "24H高": "24H high",
  "10秒": "10s",
  "30秒": "30s",
  "1分": "1m",
  "3分": "3m",
  "5分": "5m",
  "30分": "30m",
  "1小时": "1h",
  "4小时": "4h",
  "8小时": "8h",
  "1天": "1d",
  "1周": "1 week",
  "1月": "1 month",
  单向持仓: "One-way position",
  杠杆: "lever",
  仓位: "Position",
  计算结果: "Calculation results",
  盈亏: "Profit and loss",
  收益率: "Rate of return",
  计算结果仅供参考: "The calculation results are for reference only",
  成交后仓位大小: "Position size after transaction",
  "计算结果仅供参考,实际结果可能因费率差异":
    "The calculation results are for reference only, the actual results may vary due to rate differences",
  目标价格: "Target",
  开始计算: "Start calculating",
  强平价格: "Liquidation",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Before recharging, please check the name of the recharge chain carefully. If the recharge is wrong, the assets cannot be retrieved. {0}The minimum recharge amount is {1}; if the amount is less than this amount, the platform will not be able to confirm the receipt. Please do not recharge assets other than {2} to this address, otherwise it will not be possible To retrieve the assets, please do not withdraw the crowdfunding or ICO address directly, the platform will not act as a proxy for the issuance of tokens.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "The minimum withdrawal amount is {0}, the withdrawal fee will be deducted from your withdrawal amount. Before withdrawing coins, please confirm and check the receiving address, and do not withdraw {1}to an address other than {2}, otherwise the assets will not be recovered. Please do not withdraw the crowdfunding or ICO address directly, the platform will not handle the issuance of tokens.",
  退出登录: "Sign out",
  加仓: "Add",
  新增仓位: "Add",
  输入加仓金额: "Enter the amount",
  "当前可用:": "Currently available:",
  资产账单: "Asset Bill",
  保存二维码: "Save QR code",
  温馨提示: "Kind tips",
  "请注意：您当前使用的网络": "Note: Your current network",
  输入提现地址: "Enter the withdrawal address",
  "可用金额：": "Amount Available:",
  输入资产密码: "Asset password",
  可用手续费: "Available handling fee",
  "折扣%": "Discount%",
  实扣手续费: "Actual deduction fee",
  实际到账: "Actual credit",
  未设置资产密码: "Asset password not set",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "For the security of your assets, please set the asset password before withdrawing.",
  热榜: "Hot",
  涨幅榜: "Rise",
  跌幅榜: "Loser",
  成交额榜: "Turnover",
  关于我们: "About us",
  登录密码: "Login password",
  设置: "Set up",
  资产密码: "Asset password",
  修改登录密码: "Modify login password",
  原密码: "Current password",
  请输入新密码: "New password",
  请输入原密码: "Current password",
  确认密码: "Confirm password",
  确定修改: "OK to modify",
  修改资产密码: "Modify asset password",
  验证码: "Verification code",
  资产密码使用提示: "Tips for using asset password",
  "资产密码用于转移、提取资产和交易。":
    "Asset password is used to transfer, withdraw assets and trade.",
  "创建与登录密码不同的资产密码。":
    "Create a different asset password than the login password.",
  "定期更改您的资产密码。": "Change your asset password regularly.",
  提币历史: "Withdrawal history",
  "金额/余额": "Amount/Balance",
  "手续费/折扣": "Handling fee/discount",
  自选: "Optional",
  现货: "Spot",
  市价: "Market price",
  止损设置: "Stop loss setting",
  合约K线图: "Futures K-line chart",
  "24H量": "24H volume",
  "24H额": "24H amount",
  合作指南: "Cooperation Guide",
  盈亏计算: "P&L",
  当前可用: "Currently available",
  请输入加仓金额: "Please enter the increase amount",
  请重新输入加仓金额: "Please re-enter the increase amount",
  平仓数量: "Number of closed",
  欢迎登录: "Login please",
  "忘记密码?": "Forgot password?",
  "还没有账号？": "Don't have an account yet?",
  立即注册: "Sign up now",
  繁體中文: "Traditional Chinese",
  找回密码: "Retrieve password",
  下一步: "Next step",
  注册账户: "Register account",
  "请输入邀请码(选填)": "Invitation code (optional)",
  谢邀豪礼: "Invitation",
  "24小时邀请好友排名": "24 hours invite friends ranking",
  "*人": "{0}",
  "差*人": "{0}Gap",
  "已超过10万人，每月轻松赚钱":
    "Has more than 100,000 people, making money easily every month",
  最高: "Highest",
  邀请链接: "Link",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "The platform and you share the fees generated by your friends on the platform (spot, futures, leverage, flash exchange)",
  平台和您一起分享手续费: "Share the fee together",
  "*级": "{0}level",
  规则: "Rule",
  我的好友: "Friends",
  好友详情: "Friend details",
  获得好友佣金方案: "Get Friend Commission Program",
  我的等级: "My level",
  我的邀请数据: "My invitation data",
  当前等级: "Current level",
  平台奖励您: "The platform rewards you",
  最高可获取平台奖励: "Maximum reward available",
  邀请规则: "Invitation Rules",
  "邀请*级有效好友": "Invite level {0} valid friends",
  好友等级: "Friend level",
  人: "People",
  奖金派送: "Bonus delivery",
  平台奖励: "Platform reward",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "The final interpretation right belongs to the platform. If it is found that the platform rewards are obtained abnormally, all rewards will be deducted, and the account will be frozen, and the loss of assets will not be recovered.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Your account must be a valid account, and the platform determines that the valid account condition is (the account is recharged in any currency) the minimum value of {0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "The friends you invite must be valid subordinates. The platform determines that the valid subordinates are (account recharge in any currency) minimum {0} USDT value.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "The accounts of the inviter and the invitee cannot belong to the same IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "The VIP level is assessed by the number of top-level friends you invite.",
  佣金成分: "Commission component",
  收益统计: "Income Statistics",
  昨日收益: "Yesterday's",
  月收益: "Monthly income",
  获取收益: "Income",
  "总收益：": "Total:",
  "*级好友": "{0}level friend",
  理财购买: "Financial purchase",
  期限: "The term",
  可用金额: "Amount Available",
  预估收益: "Estimated earnings",
  申购上限: "Subscription limit",
  项目剩余: "Project remaining",
  "买入后预计*(SGT)开始计算收益。": "Expect {0}(SGT) to start earning.",
  计息日: "Interest date",
  申购日: "Buy date",
  到账日: "Arrival date",
  到期自动续投: "Automatic renewal after expiration",
  申购: "Buy",
  搜索理财项目: "Search for financial programs",
  超高年化随心选: "Free choice",
  "自由选择理财币种，稳定超额收益":
    "Free choice of wealth management currency to stabilize excess returns",
  理财总资产: "Amount of purchase",
  累计收益: "Cumulative income",
  申购数量: "",
  立即购买: "Buy now",
  年化收益率: "APR",
  理财订单: "Financial order",
  持有: "Hold",
  申购份额: "Subscription share",
  到账日期: "Arrival date",
  申购成功: "The subscription is successful",
  到期: "Maturity",
  是否选择做多: "Do you choose to do more",
  "可用余额为0 不能操作": "The available balance is 0 and cannot be operated",
  福利中心: "Giveaways",
  奖励记录: "Record",
  我获取到的奖励: "Bonus",
  总价值: "Total value",
  新手任务: "Novice task",
  身份认证: "Authentication",
  身份验证: "Authentication",
  去验证: "To verify",
  审核中: "Under review",
  已验证: "Verified",
  认证失败: "Authentication failed",
  基础认证: "Basic Certification",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Please note that the authentication information cannot be modified once verified, be sure to fill in the correct information",
  "国家/地区": "Country / region",
  请选择: "Please choose",
  证件类型: "Type of certificate",
  证件编码: "Document code",
  身份证: "ID card",
  护照: "Passport",
  驾驶证: "Driver license",
  请输入编码: "Please enter code",
  名字: "Name",
  请输入: "Please enter",
  中间名: "Middle name",
  选填: "Optional",
  姓氏: "last name",
  中国: "China",
  身份上传: "Identity upload",
  上传身份证: "Upload ID",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "The above materials need to be uploaded in JPG/JPEG/PNG format, and ensure that the clear edges and corners of the photo are complete and the brightness is uniform. And the size does not exceed {0}M.",
  确定提交: "Confirm Submission",
  去认证: "KYC",
  挑战任务: "Challenge mission",
  注册认证任务: "Register for certification tasks",
  完成注册认证即可领取:
    "After completing the registration certification, you can receive it",
  领取奖励: "Receive award",
  新人豪礼: "Newcomer's Gift",
  "参与人数：": "The number of participants:",
  条件: "Condition",
  入金量: "Deposit",
  完成: "Finish",
  任务奖励: "Mission rewards",
  距任务更新: "Update from task",
  "条件：": "Condition:",
  活动规则: "Rule of activity",
  奖励明细: "Reward Details",
  已获得: "Obtained",
  交易奖励: "Transaction reward",
  Win奖励: "Win Rewards",
  已领取: "Received",
  亏损金额超过: "The amount of loss exceeds",
  单笔开仓金额超过: "The amount of a single open position exceeds",
  交易量: "Trading",
  待完成: "Pending",
  入金: "Deposit",
  盈利金额超过: "Profit amount exceeds",
  开仓金额: "Amount",
  开仓金: "Open position",
  盈利: "Profit",
  亏损: "loss",
  领取: "Receive",
  未领取: "Unaccalimed",
  待领取: "Pending",
  再交易: "Re-trading",
  即可获得: "To get",
  领取成功: "Received successfully",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. All activities will be counted according to the last time of the activity, and the income will be invalid after expiration.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. The income obtained will be distributed to your bounty account, and you can exchange and withdraw it at any time according to your needs.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. The type of reward currency obtained will be issued according to the type of task.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. The final interpretation right belongs to the platform. If it is found that there are abnormal means to arbitrage the platform's task bonus, the platform has the right to freeze and clear the income you have obtained.",
  成长学院: "Help Center",
  "区块链 & 加密货币": "Blockchain & Cryptocurrency",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Your one-stop guide to cryptocurrencies, we take you on the road to cryptocurrencies.",
  "全仓合约定单的全部保证金。": "The full margin for a cross futures order.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Balance + (Unrealized P&L - handling fee - overnight fee) = new worth / used margin * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'The Unrealized P&L will directly affect the "available margin". When the unrealized profit and loss increases, the available margin will increase, and the unrealized profit and loss will decrease, and the available margin will also decrease.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Balance - (used margin) + (Unrealized P&L - handling fee - overnight fee)",
  "注:可继续用于开仓的保证金。":
    "Note: Margin that can continue to be used for opening positions.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Balance + (Unrealized P&L - handling fee - overnight fee)",
  "注:当前的资金结余。": "Note: Current fund balance.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Refers to the entire balance of the futures account, including the unavailable balance.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Note: The higher the risk rate, the lower the risk, and the lower the risk rate, the higher the risk.",
  该功能尚未开发: "This feature has not been developed",
  重置密码: "Reset Password",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Please enter 8-20 characters, must contain letters, numbers and special characters",
  修改成功: "Successfully modified",
  输入验证码: "Code",
  输入密码: "Password",
  详情说明: "Details",
  已售罄: "Sold out",
  剩余期限: "Deadline",
  限期: "Deadline",
  闪兑货币选择: "Flash currency selection",
  地区选择: "Region selection",
  "搜索国家/地区": "Search country",
  "身份信息已提交，将在*小时内审核完成":
    "Identity information has been submitted and will be reviewed within {0} hours",
  "选择国家/地区": "Select country",
  "止盈价格需高于*": "Take Profit price must be higher than {0}",
  "止损价格需低于*": "Stop loss price must be lower than {0}",
  "止盈价格需低于*": "Take Profit price must be lower than {0}",
  "止损价格需高于*": "Stop loss price must be higher than {0}",
  教程详情: "Tutorial Details",
  请输入止损价: "Please enter a stop loss price",
  活期: "Flexible",
  赎回后立即到账: "Withdraw",
  赎回: "Redemption",
  赎回理财: "Redemption",
  是否赎回当前的理财订单:
    "Whether to redeem the current wealth management order",
  维护: "Maintenance",
  "系统正在维护中……": "The system is under maintenance...",
  合约: "Futures",
  闪电兑换: "Swap",
  流水挖矿: "Cloud Mining",
  邀请豪礼: "Invitation",
  计算器: "Calculator",
  最新价: "Latest price",
  涨跌幅: "Change",
  关注币种添加自选: "Follow the currency",
  一键添加自选: "Add",
  全标已读: "Read all",
  无消息: "No news",
  "暂时还没有收到任何消息通知哦!": "No message received!",
  没有更多数据: "No more",
  闪兑: "Swap",
  从: "From",
  "可用余额：": "Balance：",
  至: "To",
  预览兑换结果: "Preview",
  闪兑规则: "Rules",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "The market flash exchange may change, please refer to the actual amount received.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "The exchange rate is set by a third party. Due to exchange costs and market fluctuations, the exchange rate you exchange may be higher than the market exchange rate. Please confirm carefully before proceeding.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "The platform charges a handling fee of about {fee}% for each exchange, which is used to pay for the exchange cost on the exchange.",
  确认汇兑: "Confirm",
  您预估得到: "Estimation",
  汇兑: "Flash Swap",
  汇兑比例: "Proportion",
  刷新: "Refresh",
  兑换: "Flash Swap",
  没有更多了: "No more",
  搜索币种: "Search",
  可用: "Available",
  我知道了: "Know",
  最新价格: "Latest price",
  确认: "Confirm",
  最大: "All",
  "风险率(%)": "Risk(%)",
  持仓: "Position",
  当前委托: "Order",
  合作交易历史记录: "History",
  重置: "Reset",
  余额: "Balance",
  现货账户: "Spot",
  合约账户: "Futures",
  WIN账户: "Win",
  赏金账户: "Gift",
  总资产折合: "Asset equivalent",
  今日收益: "Today's",
  充币: "Deposit",
  提币: "Withdraw",
  账户权益: "Account equity",
  "数量/类别": "Amount/Type",
  全部币种: "All coins",
  全部类型: "All types",
  账单信息: "Coin",
  理财赎回: "Financial redemption",
  购买理财: "Financial buy",
  收入: "Income",
  支出: "Expenditures",
  到: "To",
  资产划转: "Transfer",
  "最少*": "Min*",
  "可用资产：": "Balance",
  确认划转: "Transfer",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Transactions can only be performed by transferring assets to the corresponding account, and no handling fee will be charged for transfers between accounts.",
  币种账户选择: "Account choice",
  选择账户: "Account choice",
  划转详情: "Transfer info",
  划转明细: "Transfer info",
  收入账单: "Income info",
  支出账单: "Expenditures info",
  金额: "Amount",
  总收益: "Total",
  佣金: "Award",
  用户名: "Username",
  "已领取：": "Received：",
  "未领取：": "Not received：",
  "请选择国家/地区": "Please select country/region",
  请上传身份信息: "Please upload ID",
  请选择证件类型: "Please select document type",
  请填写证件编码: "Please fill in the ID number",
  请填写名字: "Please fill in name",
  请填写姓氏: "Please enter last name",
  单向持仓: "One-way holding",
  投资金额: "Amount",
  天: "day",
  请输入手机号: "Phone",
  搜索: "Search",
  搜索历史: "Search history",
  热门推荐: "Hot",
  "《Xspace Earn协议》": "《Xspace Earn Protocol》",
  我已了解并同意: "I understand and agree",
  协议: "protocol",
  Xspace官方中文交流群: "Xspace Official Chinese Group",
  Xspace官方英文交流群: "Xspace Official English Group",
  预计维护至: "Expected to",
  更多功能: "More",
  下载APP: "Download",
  理财: "Financial",
  推荐: "Recommend",
  Telegram官方中文频道: "Telegram official Chinese channel",
  Telegram官方英文频道: "Telegram official English channel",
  官方邮箱: "Official email",
  客服邮箱: "Customer Service Email",
  上述信息最终解释权归官方所有:
    "The final interpretation right belongs to the official",
  IOS版下载: "Download for IOS",
  Android版下载: "Download for Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Fee = Buying fee + Funds fee + Sell fee",
  资金划转: "Transfer",
  止盈: "TP",
  止损: "SL",
  自动平仓: "Automatic Close",
  委托挂单: "Entrusted pending order",
  买: "Buy",
  卖: "Sell",
  "买入/做多": "Buy/Long",
  "卖出/做空": "Sell/Short",
  详情: "Details",
  浮动涨跌: "Ups&Downs",
  最小: "Min",
  充币数量: "Recharge amount",
  请输入充币数量: "Recharge amount",
  支付截图: "Payment screenshot",
  提交: "Submit",
  上传驾驶证: "Upload driver's license",
  上传护照: "Upload passport",
  加载中: "Loading",
  上传成功: "Success",
  充值历史: "History",
  合约卖出手续费: "Contract fee",
  合约买入手续费: "Contract fee",
  系统加款: "System add-on",
  系统减款: "System reduction",
  合约资金费率: "Contract Funding Rate",
  佣金分成: "Commission share",
  U本位合约: "Contract",
  资产管理: "Assets",
  APP下载: "APP download",
  全球领先的数字理财平台:
    "The world's leading digital wealth management platform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Instantly trade hundreds of digital assets such as Bitcoin and Ethereum",
  "24H涨跌幅": "24H change",
  查看更多行情: "View more quotes",
  近24小时成交量: "Volume in the last 24 hours",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Provide hundreds of currency and contract trading pairs to meet diversified trading needs. The platform has more than 20 million users in 200 countries and regions, and is the world's leading digital asset service platform.",
  用户国家分布: "User country distribution",
  用户数: "User number",
  交易对: "Trading pair",
  服务支持: "Service support",
  "随时随地，多平台终端交易":
    "Anytime, anywhere, multi-platform terminal transactions",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "The multi-terminal is perfectly compatible and can meet the transaction needs of various scenarios at any time.",
  随时查看实时行情: "View real-time quotes at any time",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Easily buy and sell BTC, ETH, DOGE and other digital assets",
  获取您关注的加密货币价格变化预警:
    "Get alerts on cryptocurrency price changes you care about",
  "查看比特币现货、期货、期权价格":
    "View Bitcoin spot, futures, options prices",
  比较各交易所加密货币价格: "Compare cryptocurrency prices across exchanges",
  开启您的数字货币之旅: "Start your digital currency journey",
  快捷购买数字货币: "Quickly buy digital currency",
  "使用多种支付方式交易数字货币，安全快捷":
    "Use a variety of payment methods to trade digital currency, safe and fast",
  最优的交易费率: "Best transaction rate",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Preferential transaction rates, competitive VIP rights, enjoy the best quality service",
  可信赖的安全保障: "Reliable security",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Our sophisticated security measures and SAFU funds protect your digital assets from all risks.",
  交易: "Trade",
  币币市场: "Currency market",
  "24H成交量": "24H volume",
  交易所: "Exchange",
  "24H最高": "24H High",
  "24H最低": "24H Low",
  永续合约: "Contract",
  日涨跌: "Change",
  交易深度: "transaction depth",
  "资产(合约)": "Assets (Contracts)",
  历史仓位: "Historical",
  兑换记录: "Exchange record",
  类型: "Type",
  充值记录: "Recharge record",
  划转记录: "Transfer record",
  类别: "Category",
  历史账单: "Historical",
  在线充值: "Recharge",
  安全设置: "Security settings",
  用于账户登录使用: "For account login use",
  用户提现时安全验证使用:
    "Security verification and use when users withdraw cash",
  验证: "Verify",
  万: "Ten thousand",
  随时随地开启交易: "Trade. Anywhere.",
  "*货币交易所的所有功能尽在你的手中。":
    "All the functions of {0} currency exchange are in your hands.",
  "下载*货币交易所APP。": "Download the {0} currency exchange APP.",
  下载自: "Download from",
  内测版: "Closed beta",
  下载: "Download",
  扫码下载: "Scan to download",
  设置您的资产密码: "Set up your asset password",
  法币: "Fiat",
  我要买: "Buy",
  我要卖: "Sell",
  请输入金额: "Please enter the amount",
  汇率: "Exchange rate",
  获得: "Get",
  支付通道: "Payment channel",
  收款通道: "Collection channel",
  "出售过程需要务必确认好您的收款方式为本人。":
    "During the sale process, you need to confirm that your payment method is yours.",
  当前法币暂不支持交易对可尝试前往提现:
    "The current legal currency does not support the trading pair, you can try to withdraw",
  前往提现: "go to cash out",
  该法币暂无通道: "There is currently no channel for this fiat currency",
  "正在出售中，请耐心等待": "On sale, please be patient",
  请选择支付通道: "Please select a payment channel",
  请选择方式: "Please select a method",
  法币历史: "Fiat History",
  买币: "Buy",
  卖币: "Sell",
  失败: "Fail",
  已完成: "Completed",
  未付款: "Unpaid",
  待审核: "Pending review",
  打款中: "Paying",
  订单详情: "Order details",
  联系客服: "Service",
  到账金额: "Amount received",
  通道: "Aisle",
  收款人: "Payee",
  收款账户: "Accounts receivable",
  "订单出售失败，请查下方失败原因":
    "The order failed to sell, please check the reason for the failure below",
  失败原因: "Reason for failure",
  您还未进行付款: "You haven't made a payment",
  您已成功购买: "You have successfully purchased",
  已取消订单: "Order cancelled",
  "订单正在审核中，请耐心等待": "The order is under review, please be patient",
  您已成功出售: "You have successfully sold",
  "订单正在打款中，请耐心等待": "The order is being paid, please be patient",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "The payment process requires you to go to other platforms to pay for orders, please pay attention to information security.",
  当前法币暂不支持交易对可尝试前往充值:
    "The current fiat currency does not support trading pairs, you can try to recharge",
  前往充值: "Go to recharge",
  购买: "Buy",
  订单号: "Order number",
  单价: "Unit price",
  到账数量: "Amount to account",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "There are currently unpaid orders, do you want to continue to initiate a new payment order?",
  继续支付: "Continue to pay",
  重新下单: "Re-order",
  是否确定出售: "Are you sure to sell",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "After the sale is confirmed, the platform will be allocated to the buyer, please wait patiently for the platform to match.",
  出售: "Sell",
  收款方式: "Payment method",
  订单已生成: "Order has been generated",
  取消订单: "Cancel order",
  请在: "Please at",
  内完成付款: "Complete payment within",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Leave the platform, log in to the payment you specified, transfer to the seller's account below, and be sure to note in the payment:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "If no remarks are made at the time of payment, the seller will not be able to confirm the payment, resulting in the loss of assets that cannot be recovered.",
  "未在规定的时间内付款，订单都将被取消。":
    "If payment is not made within the stipulated time, the order will be cancelled.",
  姓名: "Name",
  收款姓名: "Payee name",
  开户支行: "Account opening branch",
  银行卡号: "Bank card number",
  "付款后，返回本平台": "After payment, return to this platform",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Be sure to click the "I have completed payment, notify the seller" button below',
  未点击卖家不会放款:
    "If you don't click, the seller will not release the money",
  交易条款: "Terms of the transaction",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Purchasing the source of funds, you must have legal and safe funds before you can trade",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Fraud, pyramid schemes, gambling or other illegal financial transactions are not allowed",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "After the transaction is completed, there is a risk of funds, frozen or suspected of fraud, pyramid schemes, gambling funds, we will not release U to the buyer, and give a refund",
  "已付款，通知卖家": "paid, notify seller",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "If the buyer cancels {0} orders on the same day, the same-day purchase function will be cancelled. Are you sure you want to cancel this order?",
  添加收款方式: "Add a payment method",
  是否删除此收款方式: "Whether to delete this payment method",
  删除: "Delete",
  请选择法币: "Please select fiat currency",
  机构名称: "Institution name",
  请选择机构: "Please select an institution",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "When you sell digital currency, the payment method you selected will be displayed to the buyer, please confirm that it is filled in correctly.",
  请选择银行: "Please select a bank",
  请输入姓名: "Please type in your name",
  账号: "Account",
  请输入账号: "Please enter account",
  收款码: "Receipt code",
  "银行账号/卡号": "Bank account/card number",
  "请输入银行账号/卡号": "Please enter bank account/card number",
  "开户支行（选填）": "Bank branch (optional)",
  请输入开户支行: "Please enter the bank branch",
  "加入*官方频道": "Join {0} Official Channel",
  关于: "About",
  条款: "Terms",
  其他: "Other",
  成功: "Success",
  等待: "Wait",
  作废: "Void",
  确认付款: "Confirm",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Has payment been made? If the payment is confirmed, the merchant will confirm whether the payment has been received within {0} minutes.",
  最大金额: "Maximum amount",
  最小金额: "Minimum amount",
  付款: "Payment",
  法币充值: "Fiat currency recharge",
  法币提现: "Fiat Withdrawal",
  待支付: "To be paid",
  已支付: "Paid",
  商户名: "Merchant",
  当前没有添加支付方式: "There are currently no payment methods added",
  添加后再出售: "Add to sell",
  新人大礼包: "Newcomer gift",
  注册即可领取: "Register to receive",
  立即领取: "Get it right now",
  不再提示: "Do not remind again",
  "该奖励需在APP中领取，请下载APP":
    "The reward needs to be collected in the APP, please download the APP",
  去交易: "Trade",
  期权交易: "Options",
  交易额: "Transaction amount",
  可用额度: "Available quota",
  交易周期: "Trading cycle",
  看涨: "UP",
  看跌: "DOWN",
  当前持有: "Current holdings",
  胜率: "Win rate",
  "盈利/亏损数": "Profit/Loss",
  累计实现盈亏: "Accumulated profit and loss",
  秒: "s",
  分: "m",
  小时: "h",
  天: "Days",
  周: "Week",
  下单时间: "Order time",
  剩余时间: "Time left",
  买入价: "Buying price",
  结算价: "Settlement price",
  实现盈利: "Profit",
  结算时间: "Settlement time",
  期权: "Options",
  新手教程: "Beginner's Tutorial",
  我的订单: "Order",
  赔率: "Odds",
  全部订单: "All orders",
  持有订单: "Hold order",
  历史订单: "Order history",
  输入交易额度: "Enter the amount",
  选择交易周期: "Selection period",
  去注册: "Register",
  冻结: "Freeze",
  期权支出: "Option payout",
  期权收入: "Option income",
  用户提现: "User withdrawal",
  "是否购买？": "Do you want to buy?",
  购买成功: "Successful purchase",
  请签名: "Sign, please",
  提交签名: "Submit signature",
  清空签名: "Clear signature",
  签名审核中: "Signature review",
  已提交: "Submitted",
  扫一扫下载APP: "Scan to download APP",
  新手领取大礼包: "Newbies receive spree",
  注册实名即送彩金: "Registration and real-name bonus",
  交易总额: "Total transaction",
  资产不足: "Insufficient assets",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "The assets in the Win account are insufficient and can be transferred from the funding account to this account",
  Win: "Win",
  在线充值: "Online recharge",
  比赛: "Contest",
  未开始: "Not started",
  赛程: "Schedule",
  赛果: "Result",
  已结束: "Over",
  让球: "Asian handicap",
  进球数: "Over/Under",
  大: "Over",
  小: "Under",
  胜负平: "Win/Lose",
  和局: "Drawn game",
  投注: "Betting",
  下注金额: "Bet amount",
  下注: "Betting",
  阵容: "Battle array",
  分析: "Analyze",
  输入下注金额: "Enter the bet amount",
  下注成功: "Successful bet",
  投注记录: "Betting record",
  未结算: "No settlement",
  已结算: "Settled",
  流水: "Bill flow",
  输赢: "Win or lose",
  赛时: "Game time",
  下注时间: "Betting time",
  足彩竞猜: "Football",
  查看详情: "Detail",
  输: "Lose",
  赢: "Win",
  主: "Home team",
  客: "Away team",
  主胜: "Home team victory",
  客胜: "Away team wins",
  平: "Drawn",
  已延期: "Postponed",
  账号异常: "Account exception",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Total goals",
  拍摄照片要求: "Photo requirements",
  标准拍摄: "Standard shot",
  边框缺失: "Border missing",
  照片模糊: "Photo is blurry",
  闪光强烈: "Strong flash",
  上传手持证件照: "Upload hand-held documents",
  上传证件照: "Upload ID photo",
  换一张: "Change",
  出生日期: "Date of birth",
  请选择出生日期: "Please select date of birth",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "After entering the correct graphic verification below, get the email verification code for registration",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "You have {0} certifications remaining, after which you will not be able to continue the certification",
  上半场: "First half",
  下半场: "Second half",
  独赢: "1x2",
  上半场独赢: "First half 1x2",
  下半场独赢: "Second half 1x2",
  上半场让球: "First half Handicap",
  下半场让球: "Second half Handicap",
  上半场大小球: "First half Over/Under",
  下半场大小球: "Second half Over/Under",
  波胆: "Correct Score",
  上半场波胆: "First half Correct Score",
  下半场波胆: "Second half Correct Score",
  单双: "Odd/Even",
  上半场单双: "First half Odd/Even",
  下半场单双: "Second half Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "First half Total Goal",
  下半场总进球: "Second half Total Goal",
  单: "Odd",
  双: "Even",
  中场: "Half time",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Note: Please follow this sample picture to write text on white paper and take the photo with the ID card",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Recently, a large number of cheating accounts have been discovered, and a number of illegal accounts have been punished. If there is a misjudgment as an illegal account, please contact the online customer service.",
  最小下注金额: "Minimum bet amount",
  参与活动最小下注金额: "Minimum bet amount to participate in the event",
  记住密码: "Remember password",
  比分: "Score",
  "您还未登录，请先登录": "Please login",
  立即登录: "Login",
  下注限额: "Betting limit",
  可赢金额: "Winable amount",
  闪兑详情: "Flash Details",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Due to the exchange rate, there will be a difference between the bet amount and the actual bet amount, please refer to the order.",
  开赛时间: "Start time",
  足球收入: "Football income",
  足球支出: "Football spending",
  活动详情: "Activity details",
  为世界杯喝彩: "Cheers for the world cup",
  我的竞猜: "My",
  "竞猜比赛、有机会瓜分*USDT": "Guess the game and share {0}USDT",
  "瓜分*USDT": "Share {0}USDT",
  距离活动结束还有: "End of distance",
  我的门票: "My ticket",
  竞猜结束时间: "End time",
  猜比分: "Guess the score",
  "福利派送中，完成任务即可获取门票":
    "Welfare distribution is in progress, complete the task to get tickets",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Complete the following tasks, you can get the corresponding number of tickets to participate in the competition",
  时: "Hour",
  活动: "Activity",
  竞猜记录: "Guess record",
  结果: "Result",
  任务: "Task",
  去邀请: "Invite",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "The score of each game is guessed, and ${0} can be divided into rewards for participating in the contest.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Participating in the quiz requires tickets, which can be obtained according to the tasks of the platform.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "After the guess is successful, send the screenshot of the guess result to the customer service, and the customer service will transfer the bonus to your funding account, and you can withdraw it immediately.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Any cheating is prohibited, and rewards will be void if cheating is found.",
  "完成任务后，点击咨询客服获得门票。":
    "After completing the task, click Consult Customer Service to get the ticket.",
  继续猜: "Guesse more",
  总单数: "Total count",
  赛事筛选: "League",
  球队筛选: "Team selection",
  总金额: "Lump sum",
  总流水: "Total turnover",
  派奖金额: "Bonus amount",
  下注单数: "Bet odd number",
  利润: "Profit",
  更多福利: "Welfare",
  我的奖金: "My bonus",
  未认证: "Not certified",
  总量: "Total",
  或: "Or",
  模拟交易: "Demo trading",
  体验账户不可操作: "Experience account is inoperable",
  世界杯比分竞猜: "World cup score quiz",
  "领*USDT起": "From {0}USDT",
  消息: "Information",
  滚球: "In-Play",
  是: "Yes",
  不是: "No",
  当前余额: "Balance",
  KOL招募: "KOL",
  本月净输赢: "Win/Loss(this month)",
  本月佣金: "Commission(this month)",
  佣金比例: "Commission rate",
  活跃人数: "Active number",
  新增下级: "Add subordinate",
  登录人数: "number of logins",
  首存人数: "First deposit quantity",
  数据分析: "Statistics",
  人数: "Quantity",
  新注册存款金额: "Deposit amount(N)",
  老用户存款金额: "Deposit amount(O)",
  首存金额: "First deposit amount",
  快捷入口: "Fast",
  成员管理: "Member data",
  财务报表: "Financial List",
  分红报表: "Dividend report",
  订单记录: "Order record",
  VIP专享: "VIP exclusive",
  推广工具: "Promotion tool",
  计算规则: "Rules",
  账变明细: "Account change",
  成员: "Member",
  下级概览: "Subordinate data",
  下级成员总计: "Subordinate Total",
  本月新增: "New(this month)",
  本月活跃会员: "Active(this month)",
  今日活跃会员: "Active(today)",
  本月有效活跃: "Active this month",
  活跃成员占比: "Active ratio",
  本月活跃: "Active(this month)",
  今日活跃: "Active(today)",
  下级成员: "Junior member",
  会员账号: "Member account",
  统计时间: "Statistics Time",
  筛选: "Filter",
  存款: "Deposit",
  取款: "Withdraw",
  总输赢: "Total win/loss",
  是否有效用户: "Valid(?)",
  最近登录时间: "Login time(last)",
  否: "No",
  开始时间: "Time(s)",
  结束时间: "Time(e)",
  提取: "Extract",
  总盈亏: "Profit/loss(total)",
  净盈亏: "Profit/loss(net)",
  分红: "Commission",
  概览: "Overview",
  月度详细数据: "detailed data(month)",
  未发放: "No hair",
  活跃用户: "Active user",
  有效新增会员: "New member(efficient)",
  冲正后净输赢: "Win/loss(Net)",
  上月结余: "Balance(last month)",
  净输赢: "Win/loss(Last month)",
  系统每日新加坡时间更新一次报表:
    "The system updates the report once a day in Singapore time",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Positive numbers in the data, total wins and losses, and net wins and losses in the report indicate the agent’s profit, and negative numbers indicate the agent’s loss",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "The commission data is updated every day and is for reference only, not the actual commission distribution standard",
  选择时间: "Selection time",
  足球: "Football",
  投注金额: "Bet amount",
  有效订单: "Valid order",
  下级账户: "Subordinate account",
  待成交: "Pending deal",
  下单金额: "Order amount",
  订单内容: "Order content",
  秒数: "S",
  联赛: "League",
  队伍: "Team",
  比赛时间: "Competing time",
  玩法: "Play",
  等级规则表: "Grade Rule Table",
  等级: "Grade",
  活跃会员: "active member",
  最新活跃: "Active(new)",
  额外佣金: "Award",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "The growth standard and reward system of the corresponding level are implemented every month, and only one level reward can be enjoyed.",
  渠道生成: "Create channel",
  创建: "Create",
  渠道名称: "Name",
  注册人数: "NR",
  浏览人数: "Viewers",
  构建状态: "Build status",
  禁用: "Disabled",
  启用: "Enable",
  查看: "Check",
  创建渠道: "Create channel",
  创建成功: "Successfully",
  操作成功: "Successful operation",
  渠道详情: "Channel details",
  邀请码: "Invitation code",
  访问人数: "Visitors",
  渠道地址: "channel Link",
  我的福利: "Benefits",
  充值福利: "Recharge benefits",
  当前流水: "Current flow",
  如何参与: "How to participate",
  币种充值: "Currency recharge",
  充值福利中领取福利: "Receive benefits from top-up benefits",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Rules: The recharge benefit is voluntary to receive, and the validity period is within 24 hours after the recharge. It will be invalid after the expiration date. After receiving it, the cash withdrawal function will be temporarily locked, and the cash withdrawal can be unlocked after the turnover is reached.",
  失效日期: "expiration date",
  "暂无福利领取，充值后领取":
    "No benefits to receive yet, receive after recharging",
  参与: "Join",
  充值赠送: "Recharge gift",
  "领取*%的赠送": "Receive {0}% gift",
  去领取: "Receive",
  VIP奖励: "VIP rewards",
  "当前可领取*USDT，是否确认领取":
    "Can receive {0}USDT at present, do you confirm the claim?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "After claiming, the withdrawal function will be temporarily locked, and the lock can be unlocked when your turnover reaches {0}USDT",
  充值送大礼: "Top up to get a big gift",
  "存入越多，送越多！": "The more you deposit, the more you get!",
  无效: "Invalid",
  有效: "Efficient",
  总存金额: "Deposit(total)",
  提示: "Hint",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positive numbers in total wins and losses and net wins and losses indicate platform profits, and negative numbers indicate losses. The daily data is only for reference and does not serve as the actual commission distribution standard.",
  "净盈亏：总盈亏-用户返水":
    "Net profit and loss: total profit and loss - user rebate",
  盈利方: "Benefit from",
  代理: "Delegate",
  客户: "Client",
  平局: "Tie",
  平台: "Platform",
  "已提交审核，请耐心等待": "Submitted for review, please be patient",
  充值日期: "Recharge date",
  平台本月总输赢: "Total wins and losses of the platform this month",
  KOL招募合作: "KOL recruitment cooperation",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "The platform is now open [KOL Recruitment Event], as long as you have a social media account, you can enjoy a one-time bonus with the platform to promote customers, and you can enjoy lifelong benefits.",
  级别: "Level",
  平台利润返佣: "Platform profit rebate",
  佣金案例: "Commission case",
  交易项目: "Rransaction item",
  "期权交易、合约交易、足球游戏":
    "Options trading, contract trading, football games",
  报名方式: "ways of registration",
  点击KOL招募报名: "Click KOL recruitment registration",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Welcome to join our team, the platform fully supports you to establish your own user system, and you can get the highest{0} commission, we look forward to your joining.",
  输入联系方式: "Enter contact information",
  最低活跃人数: "Minimum Active Number",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "For example: the number of active users this month ≥ {0} and the total win or loss of the platform this month ≥ {1}USDT, you belong to the level {2}, you can get {3}% commission.",
  比分竞猜: "Score quiz",
  豪礼相赠: "Gift",
  足球活动: "Football activity",
  圣诞节活动: "Christmas activities",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "You have participated in the activity and temporarily locked the withdrawal function. You need {0} USDT flow to unlock it.",
  剩余流水: "Residual water",
  助力足球: "Boost football",
  佣金累计: "Commission(A)",
  有效投注: "Valid bet",
  今日: "Today",
  今日返水: "Rebate today",
  VIP返水: "VIP rebate",
  返水记录: "Rebate record",
  成员信息: "Member information",
  基本信息: "Basic Information",
  钱包余额: "Wallet balance",
  投注信息: "Betting information",
  返水: "Rebate",
  总下注: "Total bet",
  今日输赢: "Win or lose today",
  下注动态: "Betting Dynamics",
  返水奖励: "rebate bonus",
  分红金额: "Dividend amount",
  返水支出: "Rebate payout",
  总返水: "Total rebate",
  流水总额: "Total turnover",
  返水总额: "Total Rebate",
  返水详情: "Rebate Details",
  日流水: "Daily water",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "The platform provides additional rebate rewards based on your subordinate's daily turnover, and the rewards will be distributed to the reward account at 00:00 Singapore time every day",
  "申请成功，等待审核": "The application is successful, waiting for review",
  "我出本金，盈利共分享": "I pay the principal and share the profits",
  最高分红: "highest dividend",
  投资大师比赛: "Investment Master Competition",
  "我出本金，你盈利": "I pay the principal, you profit",
  共分享: "shared",
  最高分红可得: "Maximum dividends available",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exclusive benefits for new users are coming, free ${0}, you can invest in any project on the platform after receiving it, and you can withdraw it immediately after making a profit.",
  报名领取: "Sign up to receive",
  已领取: "received",
  审核驳回: "Review rejected",
  驳回原因: "Reason for rejection",
  活动运行周期: "Activity run cycle",
  "申请成功后起至*天内完成超额收益。":
    "After the application is successful, the excess income will be completed within {0} days.",
  分红比: "Dividend ratio",
  "*日获得盈利后，可获得*%的收益额。":
    "After earning profit on the {0} day, you can get {1}% of the profit.",
  参与条件: "Participation conditions",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Users in Russia and Turkey did not participate.",
  计算项目: "calculation item",
  "合约、体育、期权": "Contracts, Sports, Options",
  我的投资: "my investment",
  参与天数: "Participation days",
  累计下注: "cumulative bet",
  累计盈亏: "Accumulated profit and loss",
  预计可分红: "Expected to pay dividends",
  常见问题: "common problem",
  什么是平台出资: "What is platform funding",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "According to users in some countries, the platform provides free funds for users to invest in projects.",
  怎么获取平台出资的福利: "How to obtain the benefits of platform contribution",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "You only need to be a user in a designated country, click the registration button above, and {0}USDT will be transferred to the bounty account under the current account after the platform review is completed, and you can transfer it to other accounts for investment.",
  什么是分红: "what is dividend",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividend means that within a specified period of time, after the income reaches 100%, 50% of the excess income can be distributed. For example: To receive 100USDT funds, the income amount is 120%.",
  "如何取得分红？": "How to get dividends?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "The activity cycle is once every {0}day. After the activity is over, it will be calculated, and the dividends will be distributed to the bounty account after meeting the activity requirements. If you do not meet the activity requirements, the system will automatically clear your income and platform contributions.",
  活动规则: "Activity Rules",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Participating accounts need to undergo KYC verification, and each account is limited to one benefit.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "The KYC of participating accounts requires the specified country to participate, and other regions are not authorized to participate. Please check whether the active country is consistent with your country.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "After successfully participating in the activity, the account will temporarily lock your withdrawal function, and your withdrawal function will be released after the activity is completed.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Please abide by the platform activity rules. If you find cheating or exploiting system loopholes for profit, the platform will freeze all funds under your account for a long time.",
  平台出资: "Platform investment",
  平台出资收回: "Platform investment recovery",
  投资大师奖励: "Investment Master Award",
  请下载APP添加收款方式: "Please download the APP to add a payment method",
  请下载APP进行身份验证: "Please download the APP for identity verification",
  请下载APP参与: "Please download the APP to participate",
  技术指标: "Technical indicators",
  主图: "Main image",
  副图: "Sub-picture",
  新注册人数: "New registrants",
  老用户存款人数: "Old user deposits",
  存款人数: "Number of depositors",
  取款人数: "Number of withdrawals",
  投注人数: "Number of bettors",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Except Indonesia, India, Bangladesh, and users who have not participated.",
  市场动态: "Market dynamics",
  外汇合约: "Foreign",
  盈亏比: "profit-loss ratio",
  委托价: "Order price",
  可用余额: "Available Balance",
  持仓额: "Position amount",
  强平价: "Strong parity",
  修改: "Revise",
  修改价位: "Modify price",
  外汇: "Forex",
  外汇账户: "Forex account",
  我的交易: "my transaction",
  未设置: "not set",
  超出最大可设数值: "Exceeds the maximum settable value",
  超出最小可设数值: "Exceeds the minimum settable value",
  止盈超出最小可设数值: "Take profit exceeds the minimum settable value",
  止损超出最大可设数值: "Stop loss exceeds the maximum settable value",
  止盈超出最大可设数值: "Take profit exceeds the maximum settable value",
  止损超出最小可设数值: "Stop loss exceeds the minimum settable value",
  挖矿: "Mining",
  交易账户: "transaction account",
  买涨: "Buy up",
  买跌: "Buy down",
  请输入正确的银行卡信息: "Please enter correct bank card information",
  联系在线客服: "Contact online customer service",
  法币交易请联系在线客服:
    "For legal currency transactions, please contact online customer service",
  提交订单: "Submit Order",
  "支付过程如有疑问,请联系在线客服":
    "If you have any questions about the payment process, please contact online customer service",
  彩金赠送: "Lottery gift",
  在线客服: "online service",
  最少投资: "minimum investment",
  "提交时间:": "Submission time:",
  提现拒绝: "Withdrawal rejected",
  认证拒绝: "Authentication rejected",
  认证通过: "Certification passed",
  请输入正确的交易额度: "Please enter the correct transaction amount",
  最大下注金额: "Maximum bet amount",
  手机号: "Phone",
  邮箱注册: "email registration",
  手机号注册: "Phone registration",
  查询: "Inquire",
  手机号登录: "Phone login",
  邮箱登录: "Email Login",
  请输入数量: "Please enter quantity",
  可用数量: "Quantity Available",
  钱包登录: "Wallet login",
  请输入正确的邀请码: "Please enter the correct invitation code",
  "请输入邀请码(必填)": "Please enter the invitation code (required)",
  输入正确的金额: "Enter the correct amount",
  法币充值: "recharge with fait",
  卢比充值: "Rupee Recharge",
  请输入法币: "Please enter currency",
  请输入IFSC: "Please enter IFSC",
  "银行编码(选填)": "Bank code (optional)",
  请输入银行编码: "Please enter bank code",
  请输入大于8位数的密码: "Please enter a password greater than 8 digits",
  添加成功: "Added successfully",
  "60秒": "60s",
  "180秒": "180s",
  "300秒": "300s",
  "2次密码不一致": "2 passwords are inconsistent",
  输入提币数量: "Enter the withdrawal amount",
  图片格式不正确: "Invalid image format",
  图片大于20M: "Image exceeds 20MB",
  请设置委托价格: "Please set the commission price",
  输入资金密码: "Enter fund password",
  验证码错误: "Verification code error",
  充值拒绝: "Recharge refused",
  请输入SSN: "Please enter SSN",
  合约交易: "contract trading",
  结算完成: "Settlement completed",
  继续下单: "Continue ordering",
  最低购买: "minimum purchase",
  最高购买: "highest purchase",
  限价: "Limit Price",
  买入价格: "Buy Price",
  买入量: "Buy Quantity",
  卖出价格: "Sell Price",
  卖出量: "Sell Quantity",
  买入: "Buy",
  卖出: "Sell",
  订单创建成功: "Order Created Successfully",
  币币买入支出: "Crypto Buy Expenditure",
  币币买入支出退还: "Crypto Buy Expenditure Refund",
  币币买入获得: "Crypto Buy Received",
  币币卖出支出: "Crypto Sell Expenditure",
  币币卖出支出退还: "Crypto Sell Expenditure Refund",
  币币卖出获得: "Crypto Sell Received",
  币币交易手续费: "Crypto Transaction Fee",
  请输入限价: "Please Enter Limit Price",
  成交: "Completed",
  等待成交: "Waiting for Completion",
  交易完成: "Transaction Completed",
  被取消: "Cancelled",
  交易时间: "Transaction Time",
  法币交易: "Fiat currency trading",
  法币出售: "Fiat currency sale",
  两次密码不一致: "The two passwords do not match",
  再次输入账户密码: "Re-enter account password",

  美国: "United States",
  韩国: "South Korea",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Yemen",
  美属维尔京群岛: "U.S. Virgin Islands",
  英属处女群岛: "British Virgin Islands",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "United Kingdom",
  阿拉伯联合酋长国: "United Arab Emirates",
  乌克兰: "Ukraine",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks and Caicos Islands",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turkey",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad and Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "East Timor",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tajikistan",
  中国台湾: "Taiwan (China)",
  叙利亚: "Syria",
  瑞士: "Switzerland",
  瑞典: "Sweden",
  斯威士兰: "Eswatini",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spain",
  南非: "South Africa",
  索马里: "Somalia",
  所罗门群岛: "Solomon Islands",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovakia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (Dutch part)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi Arabia",
  圣多美和普林西比: "São Tomé and Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts and Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent and the Grenadines",
  圣彼埃尔和密克隆岛: "Saint Pierre and Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts and Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Russia",
  罗马尼亚: "Romania",
  留尼汪: "Réunion",
  刚果共和国: "Republic of the Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Poland",
  菲律宾: "Philippines",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua New Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestine",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norway",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "New Zealand",
  新喀里多尼亚: "New Caledonia",
  荷属安德列斯群岛: "Netherlands Antilles",
  荷兰: "Netherlands",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Morocco",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexico",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Mariana Islands",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldives",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagascar",
  马其顿: "North Macedonia",
  中国澳门: "Macau (China)",
  卢森堡: "Luxembourg",
  立陶宛: "Lithuania",
  列支敦士登: "Liechtenstein",
  利比亚: "Libya",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Lebanon",
  拉脱维亚: "Latvia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kyrgyzstan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakhstan",
  约旦: "Jordan",
  日本: "Japan",
  牙买加: "Jamaica",
  象牙海岸: "Ivory Coast",
  意大利: "Italy",
  以色列: "Israel",
  爱尔兰: "Ireland",
  伊拉克: "Iraq",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "India",
  冰岛: "Iceland",
  匈牙利: "Hungary",
  中国香港: "Hong Kong (China)",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Greenland",
  希腊: "Greece",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Germany",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "French Polynesia",
  法属圭亚那: "French Guiana",
  法国: "France",
  芬兰: "Finland",
  斐济: "Fiji",
  法罗群岛: "Faroe Islands",
  埃塞俄比亚: "Ethiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Equatorial Guinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypt",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominican Republic",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Denmark",
  捷克: "Czech Republic",
  塞浦路斯: "Cyprus",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Croatia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Ivory Coast",
  库克群岛: "Cook Islands",
  科摩罗: "Comoros",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Chad",
  中非共和国: "Central African Republic",
  佛得角: "Cape Verde",
  开曼群岛: "Cayman Islands",
  开普: "Cape",
  加拿大: "Canada",
  喀麦隆: "Cameroon",
  柬埔寨: "Cambodia",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brazil",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia and Herzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgium",
  白俄罗斯: "Belarus",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaijan",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua and Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "American Samoa",
  阿尔及利亚: "Algeria",
  中国: "China",

  日收益: "Daily Earnings",
  "30天预期收益": "30-Day Expected Earnings",
  英伟达高速矿机: "NVIDIA High-Speed Mining Rig",
  去投资: "Start Investing",
  新币榜: "New",
  主题: "Theme",
  立即探索: "Explore Now",
  等您来: "Awaits You",
  最新活动: "Latest Activities",
  货币划转: "Currency Transfer",
  提现钱包: "Withdrawal Wallet",
  加密合约: "Crypto Contract",
  外汇期货: "Forex Futures",
  定期: "Fixed-Term",
  探索产品: "Explore Products",
  稳健型: "Conservative Type",
  高收益: "High-Yield",
  期货账户: "Futures Account",
  时间线: "Timeline",
  收藏: "Favorite",
  委托订单: "Pending Order",
  最新交易: "Latest Transactions",
  深度图: "Depth Chart",
  标记价格: "Mark Price",
  "24h最高价": "24h High Price",
  "24h成交量": "24h Trading Volume",
  "24h最低价": "24h Low Price",
  "24h成交额": "24h Trading Value",
  "价格(USDT)": "Price (USDT)",
  "数量(ETH)": "Quantity (ETH)",
  看空: "Short",
  余额不足: "Insufficient Balance",
  最低购买: "Minimum Purchase",
  最高购买: "Maximum Purchase",
  下单成功: "Order Placed Successfully",
  平仓成功: "Position Closed Successfully",
  请输入正确的平仓数量: "Please Enter Valid Closing Quantity",
  加仓成功: "Position Increased Successfully",
  请输入正确的加仓金额: "Please Enter Valid Additional Amount",
  收藏成功: "Added to Favorites Successfully",
  取消收藏成功: "Removed from Favorites Successfully",
  日收益率: "Daily Yield Rate",
  轻松理财: "Easy Wealth Management",
  立即申购: "Subscribe Now",
  申购日期: "Subscription Date",
  加密货币: "Cryptos",
  交割合约: "Delivery Contract",
  最小投资: "Minimum Investment",
  委托: "Entrustment",
  "当指数价格触达时，将会触发委托平仓":
    "A pending liquidation will be triggered when the index price is reached",
  预计盈利: "Estimated Profit",
  最大投资: "Maximum Investment",
  现货交易: "Spot",
  输入交易金额: "Enter amount",
  "可用额度：": "Available Limit: ",
  提现货币: "Withdrawal Currency",
  期货合约: "Futures Contract",
  加密币永续: "Crypto Perpetual",
  外汇永续: "Forex Perpetual",
  期权账户: "Options Account",
  夜间模式: "Night Mode",
  未结盈亏: "PnL",
  超额收益: "excess return",
  "安全策略，低买高卖": "Security strategy, buy low and sell high",
  投资金额应为: "The investment amount should be",
  总收益率: "Total Return",
  赎回成功: "Redemption successful",
  快捷卖币: "Quick Sell",
  修改止盈止损: "Modify TP/SL",
  白皮书: "White Paper",

  托管资金: "Custody Funds",
  托管中: "In Custody",
  预计日收益: "Estimated Daily Earnings",
  累计收益: "Total Earnings",
  周期: "Period",
  日收益: "Daily Earnings",
  限额: "Limit",
  立即托管: "Deposit Now",
  "已鎖定 請聯繫客服": "Locked, please contact customer service",
  产品列表: "Product List",
  规则: "Rules",
  创建订单: "Create Order",
  产品名称: "Product Name",
  托管周期: "Custody Period",
  等级限制: "Level Restriction",
  托管金额: "Deposit Amount",
  限额: "Limit",
  余额: "Balance",
  购买日: "Purchase Date",
  起息日: "Interest Start Date",
  派息时间: "Dividend Time",
  每天: "Every Day",
  计息结束日: "Interest End Date",
  每日收益: "Daily Earnings",
  预计收益: "Estimated Earnings",
  "收益将自动发送至您的余额账户;":
    "Earnings will be automatically sent to your balance account;",
  "您的资金没有任何风险;": "Your funds are completely safe;",
  "365*24小时不断地工作;": "Operating 24/7, 365 days a year;",
  托管中: "In Custody",
  结束: "Ended",
  今日收益: "Today's Earnings",
  剩余周期: "Remaining Period",
  进行中: "In Progress",
  已发放: "Paid Out",
  信誉分: "Reputation points",

  复制成功: "Copied successfully",
  VIP权益: "VIP Benefits",
  旧密码: "Old password",
  请输入旧密码: "Please enter old password",
  "忘记旧密码请联系客服重置。":
    "If you forgot your old password, please contact customer service to reset it.",
  去升级: "Upgrade",
  描述: "Description",
  实际存款金额: "Actual deposit amount",
  升级礼金: "Upgrade bonus",
  隔夜利息: "Overnight interest (swap)",
  自动结算: "Automatic settlement",
  等级规则: "Level rules",
  "WEB3.0币持有数据收益": "WEB3.0 coin holding data yield",
  总生产: "Total production",
  有效节点: "Active nodes",
  参与人: "Participants",
  用户收益: "User yield",
  "流动性WEB3.0输出": "Liquidity WEB3.0 output",
  总资产: "Total assets",

  ETHAI持有数据收益: "ETHAI holding data yield",
  AI量化流动性: "AI quantitative liquidity",
  现货买入手续费: "Spot purchase fee",
  现货支出: "Spot expenditure",
  现货资金费率: "Spot funding rate",
  现货卖出手续费: "Spot sale fee",
  现货收入: "Spot income",
  外汇合约支出: "Forex contract expenditure",
  外汇合约买入手续费: "Forex contract purchase fee",
  外汇合约资金费率: "Forex contract funding rate",
  外汇合约卖出手续费: "Forex contract sale fee",
  外汇合约收入: "Forex contract income",
  理财购买: "Wealth management purchase",
  VIP理财日收益: "VIP wealth management daily yield",
  VIP理财隔夜利息: "VIP wealth management overnight interest",
  VIP本金返还: "VIP principal return",
  VIP彩金发放: "VIP bonus distribution",
  VIP彩金抵扣: "VIP bonus deduction",
  隔夜利息: "Overnight interest",
  设置资产密码: "Set asset password",

  锁仓挖矿: "Locked Mining",
  一站式理财服务: "One-Stop Financial Services",
  产品: "Products",
  客服中心: "Customer Service Center",
  贷款: "Loans",
  挖矿赚不停: "Keep Earning Through Mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Locked mining generates mining profits by entrusting USDT (USD:1USDT=1USD) to the platform's high-performance mining machines within the platform mining pool.",
  产品优势: "Product Advantages",
  随存随取: "Flexible Deposit & Withdrawal",
  锁仓周期: "Lock-up Period",
  每日下发: "Daily Distribution",
  随机空投: "Random Airdrop",
  "100%资金安全保障": "100% Fund Security Guarantee",
  "100%节假日收益不间断": "100% Continuous Earnings During Holidays",
  成功锁仓后当天产出: "Earnings Start on the Same Day After Successful Lock-up",
  关于违约金: "About Penalty Fees",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "If you wish to withdraw the principal before maturity, a penalty fee will be charged. Penalty Fee = Penalty Settlement Ratio × Remaining Days × Locked Amount.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Example: The penalty settlement ratio for this locked mining product is 5%, with 3 days remaining before maturity and a locked amount of 10000U (USDT/USD). Therefore, the penalty fee = 5% × 3 × 10000 = 1500U, and the actual returned principal is 15000U - 1500U.",
  收益计算: "Profit Calculation",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "The platform offers various locked mining financial products for users to choose from. Profit calculation is as follows, for example:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "If a member locks 10000U (USDT, USD) on the platform and chooses a 7-day financial product with a daily return of 0.7%~1.8% of the locked amount, the daily earnings will be as follows:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U × 0.7% = 70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U × 1.8% = 180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "After 7 days, you can earn between 490U and 1260U. Earnings are distributed daily, and the locked principal will be automatically transferred to your funding account upon maturity.",
  正在托管的资金: "Funds Under Custody",
  签到: "Check In",
  锁仓订单: "Lock-up Orders",
  预计今日收益: "Estimated Today's Earnings",
  累计收益: "Accumulated Earnings",
  托管中的订单: "Orders Under Custody",
  单笔最少: "Minimum Per Order",
  单笔最多: "Maximum Per Order",
  日收益率: "Daily Yield Rate",
  说明: "Description",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Data statistics are based on GMT+8 time.<br>2. Daily earnings are calculated based on all settled orders between 00:00-23:59 GMT+8 (local time 00:00-23:59).<br>3. The day's earnings will be distributed uniformly between 00:00-00:10 GMT+8 on the following day.",
  知道了: "Got It",
  锁仓: "Lock Up",
  派息时间: "Distribution Time",
  每日: "Daily",
  托管资金: "Custody Funds",
  到期返回: "Return Upon Maturity",
  提前赎回: "Early Redemption",
  预计收益: "Estimated Earnings",
  认购: "Subscribe",
  热门: "Popular",
  数字货币: "Cryptos",
  贵金属: "Precious Metals",
  大宗商品: "Commodities",
  持仓明细: "Position Details",
  历史明细: "History Details",
  当前价: "Current Price",
  "↑买涨": "↑ Buy up",
  "↓买跌": "↓ Buy down",
  显示全部: "Show All",
  买入金额: "Purchase Amount",
  方向: "Direction",
  收益: "Profit",
  预期收益: "Expected Profit",
  估用保证金: "Estimated Margin",
  确认下单: "Confirm Order",
  锁定: "Locked",
  账户总资产: "Total Account Assets",
  明细: "Details",
  今日收益: "Today's Earnings",
  仓位保证金: "Position Margin",
  持有仓位: "Open Positions",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Locked Amount = Total Amount of All Unfinished Locked Mining Orders",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Data statistics are based on GMT+8 time.<br>2. Daily earnings are calculated based on all settled orders between 00:00-23:59 GMT+8 (local time 00:00-23:59).",
  充值方式: "Deposit Method",
  银行汇款: "Bank Transfer",
  "银行汇款请联系客服进行操作!":
    "Please contact customer service for bank transfer operations!",
  提款方式: "Withdrawal Method",
  "银行提款请联系客服进行操作!":
    "Please contact customer service for bank withdrawal operations!",
  资金明细: "Fund Details",
  提现记录: "Withdrawal Records",
  拒绝: "Rejected",
  通过: "Approved",
  拒绝原因: "Reason for Rejection",

  消息公告: "Announcements",
  订单: "Orders",
  个人中心: "Personal Center",
  "未到期赎回需支付一定的违约金!":
    "Early redemption requires payment of a penalty fee.",

  请输入区号: "Please enter the area code",
  "请选择国家/地区": "Please select a country/region",

  今日开盘: "Today's Open",
  昨日收盘: "Yesterday's Close",
  实名认证即送: "Receive instantly after identity verification",
  立即认证: "Verify Now",
  新用户礼包: "New User Gift Package",
  完成新人任务领取: "Complete new user tasks to claim",
  认证: "Verify",
  时间周期: "Time Period",
  支付金额: "Payment Amount",
  已平仓: "Closed",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX New User Welcome Package: Each user can receive up to",
  我已经阅读并同意: "I have read and agree to",
  隐私政策: "Privacy Policy",

  放弃奖励离开: "Abandon Gift Pack",
  继续注册: "Continue Registration",
  分钟: "Minutes",

  "请先勾选隐私政策!": "Please check the Privacy Policy first!",
  添加其他到自选: "Add others to Watchlist",
  充值最高可得: "Top up and get up to $30,000.",

  请输入格式正确的手机号: "Please enter a valid mobile phone number.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 英语



// WEBPACK FOOTER //
// ./src/lang/en.js